<template>
  <div>
    <div id="payment-request-button"></div>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { mapGetters } from 'vuex'


export default {
  props: ["stripePk"],
  data() {
    return {
      stripe: null,
      paymentRequest: null,
      prButton: null,
    };
  },
  computed: {
		...mapGetters([
			'totalCostOfInsurance',
		]),
  }, 
  async mounted() {
    // Load Stripe with your publishable key
    this.stripe = await loadStripe(this.stripePk);

    // Create a PaymentRequest object
    this.paymentRequest = this.stripe.paymentRequest({
      country: "AU", // Replace with your country code
      currency: "aud", // Replace with your currency
      total: {
        label: "Total",
        amount: this.totalCostOfInsurance*100, // Amount in cents
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    // Check if the Payment Request is available
    const result = await this.paymentRequest.canMakePayment();
    if (result) {
      const elements = this.stripe.elements();
      this.prButton = elements.create("paymentRequestButton", {
        paymentRequest: this.paymentRequest,
        style: {
          paymentRequestButton: {
            type: "default",
            theme: "dark",
            height: "64px",
          },
        },
      });
      this.prButton.mount("#payment-request-button");
    } else {
      // Hide the payment request button
      document.getElementById("payment-request-button").style.display = "none";
      // Display a message to the user
      const messageElement = document.createElement("p");
      messageElement.textContent =
        "Apple Pay is not configured or available on this device.";
      messageElement.style.textAlign = "center"; // Centres the text
      messageElement.style.marginTop = "10px";
      messageElement.style.marginBottom = "10px";
      document
        .getElementById("payment-request-button")
        .parentNode.appendChild(messageElement);
    }
    // Handle the payment method event
    this.paymentRequest.on("paymentmethod", async (ev) => {
        try {
            // Obtain the paymentMethodId (card_id)
            const paymentMethodId = ev.paymentMethod.id;
            
            // Initialize variables for card details
            let cardBrand = null;
            let cardLastFour = null;

            // Check if card details are available
            if (ev.paymentMethod.card) {
                cardBrand = ev.paymentMethod.card.brand;
                cardLastFour = ev.paymentMethod.card.last4;
            } else {
                // Handle cases where card details are not available
                cardBrand = 'Apple Pay';
                cardLastFour = 'Unavailable';
            }
            // Prepare payment data
            const paymentData = {
            payment_method_id: paymentMethodId,
            card_brand: cardBrand,
            card_last_four: cardLastFour,
            // Include other form fields as needed
            };
            this.$emit('STRIPE-PAYMENT', paymentData)

            // Complete the payment request (you can confirm the payment here if needed)
            ev.complete('success');
        } catch (err) {
            console.error(err);
            ev.complete('fail');
            // Handle the error appropriately
        }
    });
  },
  methods: {
  },
};
</script>
